import { RadioGroupLabelled } from 'components/shared/radio-group/radio-group-labelled';
import { SelectInputLabelled } from 'components/shared/select-input/select-input-labelled';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { ListFieldMetadata } from 'models/forms/fields';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function ListField({ availableItems, id, isReadOnly, translationKey, isRadioGroup, width }: ListFieldMetadata) {
  const [value, setFormData] = useFormFieldData<string>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  const { translateLabel, translateFieldLabel } = useTranslateForm();
  const label = translateLabel(translationKey ?? id);

  const items = availableItems.map(item => ({
    ...item,
    label: translateFieldLabel(item.translationKey ?? item.label),
  }));

  const compactVariant = width === 'half' && items.length > 2;

  return (
    <ErrorWrapper error={fieldError}>
      {isRadioGroup && !compactVariant ? (
        <RadioGroupLabelled
          id={id}
          label={label}
          options={items}
          value={value}
          onValueChanged={setFormData}
          isReadOnly={isReadOnly}
          isInvalid={fieldError?.severity === 'Error'}
          isHighlighted={fieldError?.severity === 'Warning'}
        />
      ) : (
        <SelectInputLabelled
          id={id}
          label={label}
          options={items}
          value={value}
          onValueChanged={setFormData}
          isReadOnly={isReadOnly}
          isInvalid={fieldError?.severity === 'Error'}
          isHighlighted={fieldError?.severity === 'Warning'}
        />
      )}
    </ErrorWrapper>
  );
}
